import { useRouter } from "@tanstack/react-router";
import { ArrowIcon } from "../icons/arrow";
import logoLtcaTranspUrl from "@/assets/logo-ltca-academy.png";


export const AuthHeader = (): JSX.Element => {
	const router = useRouter();
	return (
		<header className="relative max-h-[165px] flex justify-center items-center gap-4 bg-muted/55 px-safe-offset-4 md:px-safe-offset-6 pt-safe-offset-6 z-[1]">
			<button
				className="absolute top-0 left-0 flex items-center p-safe-offset-7 pl-safe-offset-5"
				onClick={() => {
					router.history.length > 1
						? router.history.back()
						: router.history.push("/");
				}}
			>
				<ArrowIcon />
			</button>
			<img
				alt="LCTA Logo"
				className="h-[100px] mt-[75px] "
				src={logoLtcaTranspUrl}
			/>
		</header>
	);
};
